const scaletypes = {
  "lin": "linear"
};

export default scaletypes;
